import React from 'react';
import { CustomFormatterWithTooltipAndComponent } from 'shared/components/andtComponents/TableComponents/TableComponents';
import CostCentersUnassignedAccountsIcon from './CostCentersUnassignedAccountsIcon.tsx';
import { UnassignedAccountProps } from './Interfaces.ts';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';

import styles from '../../CostCenterTable.module.scss';

interface CostCenterUnassignedNameWrapperProps {
  row: {
    unassignedAccounts?: UnassignedAccountProps[];
    [key: string]: unknown; // Allow for additional properties
  };
}

const CostCenterUnassignedNameWrapper = (props: CostCenterUnassignedNameWrapperProps) => {
  const { row } = props;
  const unassignedAccountsLength = row?.unassignedAccounts?.length || 0;

  return unassignedAccountsLength > 0 ? (
    <div className={styles.costCenterNameAndId}>
      <CustomFormatterWithTooltipAndComponent {...props} isLeftComponent>
        <CostCentersUnassignedAccountsIcon />
      </CustomFormatterWithTooltipAndComponent>
      <div className={styles.costCenterCount}>({row?.unassignedAccounts?.length})</div>
    </div>
  ) : (
    <div className={styles.costCenterNameAndId}>
      <CustomFormatterWithTooltipAndComponent {...props} isLeftComponent>
        <CostCentersUnassignedAccountsIcon noUnassignedAccounts={true} />
      </CustomFormatterWithTooltipAndComponent>
      <div className={styles.costCenterCount}>(0)</div>
      <div className={styles.noUnassignedAccounts}>
        <GenerateIcon iconName={ICONS.thumbUp.name} className={styles.thumbUpIcon} />
        Good Job!!! All Sub accounts were assigned
      </div>
    </div>
  );
};

export default CostCenterUnassignedNameWrapper;
